/*
 * @Author: atdow
 * @Date: 2025-02-24 17:42:35
 * @LastEditors: null
 * @LastEditTime: 2025-10-29 13:35:14
 * @Description: file description
 */
export const mockMarketOverviewMenu = {
  menuCode: '100000',
  parentCode: '0',
  menuName: '行业概览',
  menuIcon: '',
  url: 'market-overview',
  sort: 1000,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: 'views/marketOverview/index',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: []
}

/**
 * 品类分析（废弃，已经录进数据库）
 */
export const mockCategoryAnalysisMenu = {
  menuCode: '200000',
  parentCode: '0',
  menuName: '品类分析',
  menuIcon: '',
  url: 'category-analysis',
  sort: 2000,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: '',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: [
    {
      menuCode: '210000',
      parentCode: '200000',
      menuName: '品类驾驶舱',
      menuIcon: 'sino-icon sino-icon-dashboard',
      url: 'dashboard',
      sort: 2100,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: 'views/categoryAnalysis/dashboardRefactor/index',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: []
    },
    {
      menuCode: '220000',
      parentCode: '200000',
      menuName: '品类发展概况',
      menuIcon: 'sino-icon sino-icon-fazhan-1',
      url: 'develop-overview',
      sort: 2200,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: '',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '221000',
          parentCode: '220000',
          menuName: '品类增长模型',
          menuIcon: '',
          url: 'growth-model',
          sort: 2210,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/categoryAnalysis/developOverview/growthModel/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '222000',
          parentCode: '220000',
          menuName: '运营指标趋势',
          menuIcon: '',
          url: 'indicator-trend',
          sort: 2220,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: '',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: [
            {
              menuCode: '222100',
              parentCode: '222000',
              menuName: '品类占比',
              menuIcon: '',
              url: 'category-proportion',
              sort: 2221,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/developOverview/indicatorTrend/categoryProportion/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '222200',
              parentCode: '222000',
              menuName: '店单产',
              menuIcon: '',
              url: 'store-yield-per-unit',
              sort: 2222,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/developOverview/indicatorTrend/storeYieldPerUnit/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '222300',
              parentCode: '222000',
              menuName: '毛利',
              menuIcon: '',
              url: 'gross-profit',
              sort: 2223,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/developOverview/indicatorTrend/grossProfit/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            }
          ]
        }
      ]
    },
    {
      menuCode: '230000',
      parentCode: '200000',
      menuName: '购药者行为',
      menuIcon: 'sino-icon sino-icon-gouyaozhehangwei',
      url: 'buyer-behavior',
      sort: 2300,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: '',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '231000',
          parentCode: '230000',
          menuName: '购买者画像',
          menuIcon: '',
          url: 'buyer-portrait',
          sort: 2310,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: '',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: [
            {
              menuCode: '231100',
              parentCode: '231000',
              menuName: '渗透率',
              menuIcon: '',
              url: 'permeability',
              sort: 2311,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/buyerBehavior/buyerPortrait/permeability/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '231200',
              parentCode: '231000',
              menuName: '人群画像',
              menuIcon: '',
              url: 'crowd-portrait',
              sort: 2312,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/buyerBehavior/buyerPortrait/crowdPortrait/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '231300',
              parentCode: '231000',
              menuName: '新老客',
              menuIcon: '',
              url: 'new-and-old-customer',
              sort: 2313,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/buyerBehavior/buyerPortrait/newAndOldCustomer/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '231400',
              parentCode: '231000',
              menuName: '复购率',
              menuIcon: '',
              url: 'repurchase-rate',
              sort: 2314,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/buyerBehavior/buyerPortrait/repurchaseRate/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            }
          ]
        },
        {
          menuCode: '232000',
          parentCode: '230000',
          menuName: '购药行为',
          menuIcon: '',
          url: 'drug-purchase-behavior',
          sort: 2320,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: '',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: [
            {
              menuCode: '232100',
              parentCode: '232000',
              menuName: '价格驱动力',
              menuIcon: '',
              url: 'price-driven',
              sort: 2321,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/buyerBehavior/drugPurchaseBehavior/priceDriven/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '232200',
              parentCode: '232000',
              menuName: '件数驱动力',
              menuIcon: '',
              url: 'quantity-driven',
              sort: 2322,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/buyerBehavior/drugPurchaseBehavior/quantityDriven/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            }
          ]
        },
        {
          menuCode: '233000',
          parentCode: '230000',
          menuName: '关联购买',
          menuIcon: '',
          url: 'relativePurchase',
          sort: 2330,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/categoryAnalysis/buyerBehavior/relativePurchase/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '234000',
          parentCode: '230000',
          menuName: '品牌流转',
          menuIcon: '',
          url: 'brandFlow',
          sort: 2340,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/categoryAnalysis/buyerBehavior/brandFlow/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
      ]
    },
    {
      menuCode: '240000',
      parentCode: '200000',
      menuName: '细分赛道',
      menuIcon: 'sino-icon sino-icon-xifensaidao',
      url: 'segmented-tracks',
      sort: 2400,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: '',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '241000',
          parentCode: '240000',
          menuName: '细分产品定位',
          menuIcon: '',
          url: 'productPosition',
          sort: 2410,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/categoryAnalysis/segmentedTracks/productPosition/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '242000',
          parentCode: '240000',
          menuName: '增长模型对比',
          menuIcon: '',
          url: 'model-compare',
          sort: 2420,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/categoryAnalysis/segmentedTracks/modelCompare/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '243000',
          parentCode: '240000',
          menuName: '运营指标对比',
          menuIcon: '',
          url: 'indicator-compare',
          sort: 2430,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/categoryAnalysis/segmentedTracks/indicatorCompare/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '244000',
          parentCode: '240000',
          menuName: '画像对比',
          menuIcon: '',
          url: 'portrait-compare',
          sort: 2440,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: '',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: [
            {
              menuCode: '244100',
              parentCode: '244000',
              menuName: '渗透率',
              menuIcon: '',
              url: 'permeability',
              sort: 2441,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/portraitCompare/permeability/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '244200',
              parentCode: '244000',
              menuName: '性别画像',
              menuIcon: '',
              url: 'sex-portrait',
              sort: 2442,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/portraitCompare/sexPortrait/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '244300',
              parentCode: '244000',
              menuName: '年龄画像',
              menuIcon: '',
              url: 'age-portrait',
              sort: 2443,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/portraitCompare/agePortrait/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '244400',
              parentCode: '244000',
              menuName: '新老客',
              menuIcon: '',
              url: 'new-and-old-customer',
              sort: 2444,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/portraitCompare/newAndOldCustomer/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '244500',
              parentCode: '244000',
              menuName: '复购率',
              menuIcon: '',
              url: 'repurchase-rate',
              sort: 2445,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/portraitCompare/repurchaseRate/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            }
          ]
        },
        {
          menuCode: '245000',
          parentCode: '240000',
          menuName: '购买行为对比',
          menuIcon: '',
          url: 'purchase-behavior-compare',
          sort: 2450,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: '',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: [
            {
              menuCode: '245100',
              parentCode: '245000',
              menuName: '指标一览',
              menuIcon: '',
              url: 'indicator-overview',
              sort: 2451,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/purchaseBehaviorCompare/indicatorOverview/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '245200',
              parentCode: '245000',
              menuName: '价格驱动力',
              menuIcon: '',
              url: 'price-driven',
              sort: 2452,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/purchaseBehaviorCompare/priceDriven/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '245300',
              parentCode: '245000',
              menuName: '件数驱动力',
              menuIcon: '',
              url: 'quantity-driven',
              sort: 2453,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/purchaseBehaviorCompare/quantityDriven/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '245400',
              parentCode: '245000',
              menuName: '人均消费金额/件数',
              menuIcon: '',
              url: 'per-capita-consumption-amount-or-quantity',
              sort: 2454,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress:
                'views/categoryAnalysis/segmentedTracks/purchaseBehaviorCompare/perCapitaConsumptionAmountOrQuantity/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            }
          ]
        },
        {
          menuCode: '246000',
          parentCode: '240000',
          menuName: '关联与流转',
          menuIcon: '',
          url: 'relative-and-slip',
          sort: 2460,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: '',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: [
            {
              menuCode: '246100',
              parentCode: '246000',
              menuName: '关联购买',
              menuIcon: '',
              url: 'relative-purchase',
              sort: 2461,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/relativeAndSlip/relativePurchase/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2
            },
            {
              menuCode: '246200',
              parentCode: '246000',
              menuName: '品牌流转',
              menuIcon: '',
              url: 'brand-flow',
              sort: 2462,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/categoryAnalysis/segmentedTracks/relativeAndSlip/brandFlow/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2
            }
            // {
            //   menuCode: '246300',
            //   parentCode: '8',
            //   menuName: '竞品流转',
            //   menuIcon: '',
            //   url: 'competitors-slip',
            //   sort: 101,
            //   type: 1,
            //   description: '',
            //   channel: 1,
            //   perms: null,
            //   open: null,
            //   parentName: null,
            //   packageAddress: 'views/categoryAnalysis/segmentedTracks/relativeAndSlip/competitorsSlip/index',
            //   showType: 1,
            //   menuLevel: 2,
            //   menuType: 2
            // }
          ]
        },
        {
          menuCode: '247000',
          parentCode: '240000',
          menuName: '渠道覆盖对比',
          menuIcon: '',
          url: 'trench-coverage-compare',
          sort: 2470,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/categoryAnalysis/segmentedTracks/trenchCoverageCompare/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
      ]
    }
    // {
    //   menuCode: '1',
    //   parentCode: '8',
    //   menuName: '品类场景库',
    //   menuIcon: 'sino-icon sino-icon-box',
    //   url: 'scene-library',
    //   sort: 101,
    //   type: 1,
    //   description: '',
    //   channel: 1,
    //   perms: null,
    //   open: null,
    //   parentName: null,
    //   packageAddress: '',
    //   showType: 1,
    //   menuLevel: 2,
    //   menuType: 2,
    //   child: [
    //     {
    //       menuCode: '1',
    //       parentCode: '8',
    //       menuName: '市场表现',
    //       menuIcon: '',
    //       url: 'market-performance',
    //       sort: 101,
    //       type: 1,
    //       description: '',
    //       channel: 1,
    //       perms: null,
    //       open: null,
    //       parentName: null,
    //       packageAddress: '',
    //       showType: 1,
    //       menuLevel: 2,
    //       menuType: 2,
    //       child: [
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '总览患者增长模型',
    //           menuIcon: '',
    //           url: 'overview-model',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/categoryAnalysis/marketPerformance/overviewModel/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '品类运营结果',
    //           menuIcon: '',
    //           url: 'operation-results',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/categoryAnalysis/marketPerformance/operationResults/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         }
    //       ]
    //     },
    //     {
    //       menuCode: '1',
    //       parentCode: '8',
    //       menuName: '客群特征',
    //       menuIcon: '',
    //       url: 'customer-characteristics',
    //       sort: 101,
    //       type: 1,
    //       description: '',
    //       channel: 1,
    //       perms: null,
    //       open: null,
    //       parentName: null,
    //       packageAddress: '',
    //       showType: 1,
    //       menuLevel: 2,
    //       menuType: 2,
    //       child: [
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '人群增长机会',
    //           menuIcon: '',
    //           url: 'member-opportunities',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/categoryAnalysis/customerCharacteristics/memberOpportunities/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '细分赛道增长机会',
    //           menuIcon: '',
    //           url: 'track-opportunities',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/categoryAnalysis/customerCharacteristics/trackOpportunities/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         }
    //       ]
    //     },
    //     {
    //       menuCode: '1',
    //       parentCode: '8',
    //       menuName: '品类/品种机会挖掘',
    //       menuIcon: '',
    //       url: 'opportunity-mining',
    //       sort: 101,
    //       type: 1,
    //       description: '',
    //       channel: 1,
    //       perms: null,
    //       open: null,
    //       parentName: null,
    //       packageAddress: '',
    //       showType: 1,
    //       menuLevel: 2,
    //       menuType: 2,
    //       child: [
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '品种细分赛道增长趋势',
    //           menuIcon: '',
    //           url: 'variety-trend',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/categoryAnalysis/opportunityMining/varietyTrend/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '销售件数驱动',
    //           menuIcon: '',
    //           url: 'sales-drive',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/categoryAnalysis/opportunityMining/salesDrive/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '价格驱动',
    //           menuIcon: '',
    //           url: 'price-drive',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/categoryAnalysis/opportunityMining/priceDrive/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         }
    //       ]
    //     }
    //   ]
    // },
  ]
}

export const mockRegionAnalysisMenu = {
  menuCode: '500000',
  parentCode: '0',
  menuName: '区域分析',
  menuIcon: '',
  url: 'region-analysis',
  sort: 3500,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: '',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: [
    {
      menuCode: '1',
      parentCode: '8',
      menuName: '品牌驾驶舱',
      menuIcon: 'sino-icon sino-icon-dashboard',
      url: 'brand-dashboard',
      sort: 101,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: 'views/regionAnalysis/brandDashboard/index',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: []
    },
    {
      menuCode: '1',
      parentCode: '8',
      menuName: '省区细分格局',
      menuIcon: 'sino-icon sino-icon-pattern',
      url: 'subdivision-pattern',
      sort: 101,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '品牌竞争格局',
          menuIcon: '',
          url: 'brand-competition-pattern',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/subdivisionPattern/brandCompetitionPattern/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '省区增长模型对比',
          menuIcon: '',
          url: 'growth-model-compare',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/subdivisionPattern/growthModelCompare/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '品牌运营指标',
          menuIcon: '',
          url: 'brand-operation-indicator',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: [
            {
              menuCode: '1',
              parentCode: '8',
              menuName: '市场占比及变化',
              menuIcon: '',
              url: 'market-proportion-and-changes',
              sort: 101,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress:
                'views/regionAnalysis/subdivisionPattern/brandOperationIndicator/marketProportionAndChanges/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '1',
              parentCode: '8',
              menuName: '店单产对比',
              menuIcon: '',
              url: 'store-yield-compare',
              sort: 101,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/regionAnalysis/subdivisionPattern/brandOperationIndicator/storeYieldCompare/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '1',
              parentCode: '8',
              menuName: '毛利对比',
              menuIcon: '',
              url: 'gross-profit-compare',
              sort: 101,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress:
                'views/regionAnalysis/subdivisionPattern/brandOperationIndicator/grossProfitCompare/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '1',
              parentCode: '8',
              menuName: '区域覆盖',
              menuIcon: '',
              url: 'region-coverage',
              sort: 101,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress: 'views/regionAnalysis/subdivisionPattern/brandOperationIndicator/regionCoverage/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            },
            {
              menuCode: '1',
              parentCode: '8',
              menuName: '多省区运营一览',
              menuIcon: '',
              url: 'multi-provincial-operation-overview',
              sort: 101,
              type: 1,
              description: '',
              channel: 1,
              perms: null,
              open: null,
              parentName: null,
              packageAddress:
                'views/regionAnalysis/subdivisionPattern/brandOperationIndicator/multiProvincialOperationOverview/index',
              showType: 1,
              menuLevel: 2,
              menuType: 2,
              child: []
            }
          ]
        }
      ]
    },
    {
      menuCode: '1',
      parentCode: '8',
      menuName: '区域购药者画像',
      menuIcon: 'sino-icon sino-icon-a-mapportrait',
      url: 'drug-buyer-portrait',
      sort: 101,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '省区购药者画像总览',
          menuIcon: '',
          url: 'drug-buyer-portrait-overview',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerPortrait/drugBuyerPortraitOverview/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '渗透率',
          menuIcon: '',
          url: 'permeability',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerPortrait/permeability/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '性别',
          menuIcon: '',
          url: 'sex',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerPortrait/sex/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '年龄',
          menuIcon: '',
          url: 'age',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerPortrait/age/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '新老客',
          menuIcon: '',
          url: 'new-and-old-customer',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerPortrait/newAndOldCustomer/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '复购',
          menuIcon: '',
          url: 'repurchase',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerPortrait/repurchase/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
      ]
    },
    {
      menuCode: '1',
      parentCode: '8',
      menuName: '区域购药者对比',
      menuIcon: 'sino-icon sino-icon-user-vs',
      url: 'drug-buyer-compare',
      sort: 101,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '购药者&终端机会格局',
          menuIcon: '',
          url: 'drug-buyer-and-terminal-opportunity-pattern',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerCompare/drugBuyerAndTerminalOpportunityPattern/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '1',
          parentCode: '8',
          menuName: '多省区行为',
          menuIcon: '',
          url: 'multi-province-and-region-behavior',
          sort: 101,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/regionAnalysis/drugBuyerCompare/multiProvinceAndRegionBehavior/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
        // {
        //   menuCode: '1',
        //   parentCode: '8',
        //   menuName: '关联机会',
        //   menuIcon: '',
        //   url: 'relative-opportunity',
        //   sort: 101,
        //   type: 1,
        //   description: '',
        //   channel: 1,
        //   perms: null,
        //   open: null,
        //   parentName: null,
        //   packageAddress: 'views/regionAnalysis/drugBuyerCompare/relativeOpportunity/index',
        //   showType: 1,
        //   menuLevel: 2,
        //   menuType: 2,
        //   child: []
        // },
      ]
    }
  ]
}

/**
 * 品牌分析（废弃，已经录进数据库）
 */
export const mockBrandAnalysisMenu = {
  menuCode: '300000',
  parentCode: '0',
  menuName: '品牌分析',
  menuIcon: '',
  url: 'brand-analysis',
  sort: 3000,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: '',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: [
    {
      menuCode: '310000',
      parentCode: '300000',
      menuName: '品牌驾驶舱',
      menuIcon: 'sino-icon sino-icon-dashboard',
      url: 'dashboard',
      sort: 3100,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: 'views/brandAnalysis/dashboardRefactor/index',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: []
    },
    {
      menuCode: '320000',
      parentCode: '300000',
      menuName: '品牌画像卡片',
      menuIcon: 'sino-icon sino-icon-a-picturecard',
      url: 'portrait-card',
      sort: 3200,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: 'views/brandAnalysis/portraitCard/index',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: []
    },
    {
      menuCode: '330000',
      parentCode: '300000',
      menuName: '品牌竞争概览',
      menuIcon: 'sino-icon sino-icon-a-brandcompetition',
      url: 'competition-overview',
      sort: 3300,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '331000',
          parentCode: '330000',
          menuName: '品牌竞争格局',
          menuIcon: '',
          url: 'competition-pattern',
          sort: 3310,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/competitionOverview/competitionPatternV2/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '332000',
          parentCode: '330000',
          menuName: '综合竞争力',
          menuIcon: '',
          url: 'comprehensive-competitive-power',
          sort: 3320,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/competitionOverview/comprehensiveCompetitivePower/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '333000',
          parentCode: '330000',
          menuName: '增长驱动模型',
          menuIcon: '',
          url: 'growth-model',
          sort: 3330,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/competitionOverview/growthModel/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '334000',
          parentCode: '330000',
          menuName: '品牌运营指标对比',
          menuIcon: '',
          url: 'brand-operation-compare',
          sort: 3340,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/brandOperationCompare/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '335000',
          parentCode: '330000',
          menuName: '多品牌运营指标趋势',
          menuIcon: '',
          url: 'brand-operation-trend',
          sort: 3350,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/brandOperationTrend/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '336000',
          parentCode: '330000',
          menuName: '品规运营趋势',
          menuIcon: '',
          url: 'spec-operation-trend',
          sort: 3360,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/specOperationTrend/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
        // NOTE v1.4.1模块相关优化版本屏蔽
        // {
        //   menuCode: '1',
        //   parentCode: '8',
        //   menuName: '品牌运营榜',
        //   menuIcon: '',
        //   url: 'operation-rank',
        //   sort: 101,
        //   type: 1,
        //   description: '',
        //   channel: 1,
        //   perms: null,
        //   open: null,
        //   parentName: null,
        //   packageAddress: 'views/brandAnalysis/competitionOverview/operationRank/index',
        //   showType: 1,
        //   menuLevel: 2,
        //   menuType: 2,
        //   child: []
        // },
        // NOTE v1.4.1模块相关优化版本屏蔽
        // {
        //   menuCode: '1',
        //   parentCode: '8',
        //   menuName: '运营指标趋势',
        //   menuIcon: '',
        //   url: 'indicator-trend',
        //   sort: 101,
        //   type: 1,
        //   description: '',
        //   channel: 1,
        //   perms: null,
        //   open: null,
        //   parentName: null,
        //   showType: 1,
        //   menuLevel: 2,
        //   menuType: 2,
        //   child: [
        //     {
        //       menuCode: '1',
        //       parentCode: '8',
        //       menuName: '品牌占比及变化',
        //       menuIcon: '',
        //       url: 'brand-proportion-and-trend',
        //       sort: 101,
        //       type: 1,
        //       description: '',
        //       channel: 1,
        //       perms: null,
        //       open: null,
        //       parentName: null,
        //       packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/brandProportionAndTrend/index',
        //       showType: 1,
        //       menuLevel: 2,
        //       menuType: 2,
        //       child: []
        //     },
        //     {
        //       menuCode: '1',
        //       parentCode: '8',
        //       menuName: '店单产对比',
        //       menuIcon: '',
        //       url: 'store-unit-production-compare',
        //       sort: 101,
        //       type: 1,
        //       description: '',
        //       channel: 1,
        //       perms: null,
        //       open: null,
        //       parentName: null,
        //       packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/storeUnitProductionCompare/index',
        //       showType: 1,
        //       menuLevel: 2,
        //       menuType: 2,
        //       child: []
        //     },
        //     {
        //       menuCode: '1',
        //       parentCode: '8',
        //       menuName: '毛利对比',
        //       menuIcon: '',
        //       url: 'gross-profit-compare',
        //       sort: 101,
        //       type: 1,
        //       description: '',
        //       channel: 1,
        //       perms: null,
        //       open: null,
        //       parentName: null,
        //       packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/grossProfitCompare/index',
        //       showType: 1,
        //       menuLevel: 2,
        //       menuType: 2,
        //       child: []
        //     },
        //     {
        //       menuCode: '1',
        //       parentCode: '8',
        //       menuName: '覆盖对比',
        //       menuIcon: '',
        //       url: 'coverage-compare',
        //       sort: 101,
        //       type: 1,
        //       description: '',
        //       channel: 1,
        //       perms: null,
        //       open: null,
        //       parentName: null,
        //       packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/coverageCompare/index',
        //       showType: 1,
        //       menuLevel: 2,
        //       menuType: 2,
        //       child: []
        //     },
        //     {
        //       menuCode: '1',
        //       parentCode: '8',
        //       menuName: '多品牌运营',
        //       menuIcon: '',
        //       url: 'multi-brand-operation',
        //       sort: 101,
        //       type: 1,
        //       description: '',
        //       channel: 1,
        //       perms: null,
        //       open: null,
        //       parentName: null,
        //       packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/multiBrandOperation/index',
        //       showType: 1,
        //       menuLevel: 2,
        //       menuType: 2,
        //       child: []
        //     }
        //   ]
        // }
      ]
    },
    {
      menuCode: '340000',
      parentCode: '300000',
      menuName: '品牌画像洞察',
      menuIcon: 'sino-icon sino-icon-a-usercomparison',
      url: 'portrait-compare',
      sort: 3400,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '341000',
          parentCode: '340000',
          menuName: '品牌定位格局',
          menuIcon: '',
          url: 'production-position-pattern',
          sort: 3410,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/portraitCompare/productionPositionPattern/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '342000',
          parentCode: '340000',
          menuName: '品牌购药画像总览',
          menuIcon: '',
          url: 'drug-purchase-portrait-overview',
          sort: 3420,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/portraitCompare/drugPurchasePortraitOverview/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '343000',
          parentCode: '340000',
          menuName: '渗透率',
          menuIcon: '',
          url: 'permeability',
          sort: 3430,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/portraitCompare/permeability/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '344000',
          parentCode: '340000',
          menuName: '性别',
          menuIcon: '',
          url: 'sex',
          sort: 3440,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/portraitCompare/sex/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '345000',
          parentCode: '340000',
          menuName: '年龄',
          menuIcon: '',
          url: 'age',
          sort: 3450,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/portraitCompare/age/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '346000',
          parentCode: '340000',
          menuName: '新老客',
          menuIcon: '',
          url: 'new-and-old-customer',
          sort: 3460,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/portraitCompare/newAndOldCustomer/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '347000',
          parentCode: '340000',
          menuName: '复购',
          menuIcon: '',
          url: 'repurchase',
          sort: 3470,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/portraitCompare/repurchase/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
      ]
    },
    {
      menuCode: '350000',
      parentCode: '300000',
      menuName: '购药行为对比',
      menuIcon: 'sino-icon sino-icon-gouyaozhehangwei',
      url: 'drug-purchase-behavior-compare',
      sort: 3500,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        // NOTE v1.4.1模块相关优化版本屏蔽
        // {
        //   menuCode: '1',
        //   parentCode: '8',
        //   menuName: '品牌综合竞争力',
        //   menuIcon: '',
        //   url: 'comprehensive-competitive-power',
        //   sort: 101,
        //   type: 1,
        //   description: '',
        //   channel: 1,
        //   perms: null,
        //   open: null,
        //   parentName: null,
        //   packageAddress: 'views/brandAnalysis/drugPurchaseBehaviorCompare/comprehensiveCompetitivePower/index',
        //   showType: 1,
        //   menuLevel: 2,
        //   menuType: 2,
        //   child: []
        // },
        {
          menuCode: '351000',
          parentCode: '350000',
          menuName: '价格驱动力',
          menuIcon: '',
          url: 'price-drive',
          sort: 3510,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/drugPurchaseBehaviorCompare/priceDrive/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '352000',
          parentCode: '350000',
          menuName: '件数驱动力',
          menuIcon: '',
          url: 'number-drive',
          sort: 3520,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/drugPurchaseBehaviorCompare/numberDrive/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '353000',
          parentCode: '350000',
          menuName: '人均消费金额/件数',
          menuIcon: '',
          url: 'per-capita-consumption-amount-or-quantity',
          sort: 3530,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/drugPurchaseBehaviorCompare/perCapitaConsumptionAmountOrQuantity/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '354000',
          parentCode: '350000',
          menuName: '可服用天数',
          menuIcon: '',
          url: 'number-of-days-for-taking-medicine',
          sort: 3540,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/drugPurchaseBehaviorCompare/numberOfDaysForTakingMedicine/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
      ]
    },
    {
      menuCode: '360000',
      parentCode: '300000',
      menuName: '关联与流转',
      menuIcon: 'sino-icon sino-icon-exchange',
      url: 'relative-and-slip',
      sort: 3600,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '361000',
          parentCode: '360000',
          menuName: '关联分析',
          menuIcon: '',
          url: 'relative-analysis',
          sort: 3610,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/relativeAndSlip/relativeAnalysis/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '362000',
          parentCode: '360000',
          menuName: '品牌流转',
          menuIcon: '',
          url: 'slip-analysis',
          sort: 3620,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/relativeAndSlip/slipAnalysis/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        },
        {
          menuCode: '363000',
          parentCode: '360000',
          menuName: '区域购药者对比',
          menuIcon: '',
          url: 'region-drug-buyer-compare',
          sort: 3630,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/brandAnalysis/relativeAndSlip/regionDrugBuyerCompare/index',
          showType: 1,
          menuLevel: 2,
          menuType: 2,
          child: []
        }
      ]
    }
    // NOTE 历史菜单（废弃）
    // {
    //   menuCode: '1',
    //   parentCode: '8',
    //   menuName: '品牌场景库',
    //   menuIcon: 'sino-icon sino-icon-box',
    //   url: 'scene-library',
    //   sort: 101,
    //   type: 1,
    //   description: '',
    //   channel: 1,
    //   perms: null,
    //   open: null,
    //   parentName: null,
    //   packageAddress: '',
    //   showType: 1,
    //   menuLevel: 2,
    //   menuType: 2,
    //   child: [
    //     {
    //       menuCode: '1',
    //       parentCode: '8',
    //       menuName: '终端运营监测',
    //       menuIcon: '',
    //       url: 'operation-results',
    //       sort: 101,
    //       type: 1,
    //       description: '',
    //       channel: 1,
    //       perms: null,
    //       open: null,
    //       parentName: null,
    //       packageAddress: '',
    //       showType: 1,
    //       menuLevel: 2,
    //       menuType: 2,
    //       child: [
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '运营指标概览',
    //           menuIcon: '',
    //           url: 'operation-results',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/brandAnalysis/operationResults/operationAnalysis/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '品牌驱动力',
    //           menuIcon: '',
    //           url: 'drive',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: '',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: [
    //             {
    //               menuCode: '1',
    //               parentCode: '8',
    //               menuName: '销售件数驱动力',
    //               menuIcon: '',
    //               url: 'sales',
    //               sort: 101,
    //               type: 1,
    //               description: '',
    //               channel: 1,
    //               perms: null,
    //               open: null,
    //               parentName: null,
    //               packageAddress: 'views/brandAnalysis/drive/sales/index',
    //               showType: 1,
    //               menuLevel: 2,
    //               menuType: 2,
    //               child: []
    //             },
    //             {
    //               menuCode: '1',
    //               parentCode: '8',
    //               menuName: '价格驱动力',
    //               menuIcon: '',
    //               url: 'price',
    //               sort: 101,
    //               type: 1,
    //               description: '',
    //               channel: 1,
    //               perms: null,
    //               open: null,
    //               parentName: null,
    //               packageAddress: 'views/brandAnalysis/drive/price/index',
    //               showType: 1,
    //               menuLevel: 2,
    //               menuType: 2,
    //               child: []
    //             },
    //             {
    //               menuCode: '1',
    //               parentCode: '8',
    //               menuName: '渠道驱动力 ',
    //               menuIcon: '',
    //               url: 'channel',
    //               sort: 101,
    //               type: 1,
    //               description: '',
    //               channel: 1,
    //               perms: null,
    //               open: null,
    //               parentName: null,
    //               packageAddress: 'views/brandAnalysis/drive/channel/index',
    //               showType: 1,
    //               menuLevel: 2,
    //               menuType: 2,
    //               child: []
    //             }
    //           ]
    //         }
    //       ]
    //     },
    //     {
    //       menuCode: '1',
    //       parentCode: '8',
    //       menuName: '品牌增长监测',
    //       menuIcon: '',
    //       url: 'growthAnalysis',
    //       sort: 101,
    //       type: 1,
    //       description: '',
    //       channel: 1,
    //       perms: null,
    //       open: null,
    //       parentName: null,
    //       packageAddress: '',
    //       showType: 1,
    //       menuLevel: 2,
    //       menuType: 2,
    //       child: [
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '品牌增长模型',
    //           menuIcon: '',
    //           url: 'growth-model',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/brandAnalysis/operationResults/growthModel/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '品牌画像',
    //           menuIcon: '',
    //           url: 'member-opportunities',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/brandAnalysis/growthAnalysis/memberOpportunities/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '竞品分析',
    //           menuIcon: '',
    //           url: 'compare-analysis',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/brandAnalysis/operationResults/compareAnalysis/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         },
    //         {
    //           menuCode: '1',
    //           parentCode: '8',
    //           menuName: '流转分析',
    //           menuIcon: '',
    //           url: 'slip-analysis',
    //           sort: 101,
    //           type: 1,
    //           description: '',
    //           channel: 1,
    //           perms: null,
    //           open: null,
    //           parentName: null,
    //           packageAddress: 'views/brandAnalysis/growthAnalysis/slipAnalysis/index',
    //           showType: 1,
    //           menuLevel: 2,
    //           menuType: 2,
    //           child: []
    //         }
    //       ]
    //     }
    //   ]
    // },
    // {
    //   menuCode: '1',
    //   parentCode: '8',
    //   menuName: '区域监测',
    //   menuIcon: 'sino-icon sino-icon-a-mapmonitor',
    //   url: 'region-monitor',
    //   sort: 101,
    //   type: 1,
    //   description: '',
    //   channel: 1,
    //   perms: null,
    //   open: null,
    //   parentName: null,
    //   packageAddress: 'views/brandAnalysis/growthAnalysis/regionAnalysis/index',
    //   showType: 1,
    //   menuLevel: 2,
    //   menuType: 2,
    //   child: []
    // },
  ]
}

/**
 * 指标库（废弃，已经录进数据库）
 */
export const mockIndicatorLibraryMenu = {
  menuCode: '400000',
  parentCode: '0',
  menuName: '指标库',
  menuIcon: '',
  url: 'indicator-library',
  sort: 400000,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: '',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: [
    {
      menuCode: '410000',
      parentCode: '400000',
      menuName: '增长驱动模型',
      menuIcon: 'sino-icon sino-icon-model',
      url: 'growth-model',
      sort: 410000,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: 'views/indicatorLibrary/growthModel/index',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: []
    },
    {
      menuCode: '420000',
      parentCode: '400000',
      menuName: '市场表现概览',
      menuIcon: 'sino-icon sino-icon-a-marketanalysis',
      url: 'market-performance',
      sort: 420000,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: 'views/indicatorLibrary/marketPerformance/index',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: []
    },
    {
      menuCode: '430000',
      parentCode: '400000',
      menuName: '门店运营指标',
      menuIcon: 'sino-icon sino-icon-indicator',
      url: 'store-operation-indicator',
      sort: 430000,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: '',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '431000',
          parentCode: '430000',
          menuName: '销售额/订单量占比',
          menuIcon: '',
          url: 'sales-volume-and-order-proportion',
          sort: 431000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/storeOperationIndicator/salesVolumeAndOrderProportion/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '432000',
          parentCode: '430000',
          menuName: '店均销售额/订单量',
          menuIcon: '',
          url: 'sales-volume-and-order',
          sort: 432000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/storeOperationIndicator/salesVolumeAndOrder/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '433000',
          parentCode: '430000',
          menuName: '进货/销售均价',
          menuIcon: '',
          url: 'purchase-goods-dnd-sales-average-price',
          sort: 433000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/storeOperationIndicator/purchaseGoodsAndSalesAveragePrice/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '434000',
          parentCode: '430000',
          menuName: '毛利额/毛利率',
          menuIcon: '',
          url: 'gross-profit',
          sort: 434000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/storeOperationIndicator/grossProfit/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '435000',
          parentCode: '430000',
          menuName: '铺货率/动销率',
          menuIcon: '',
          url: 'stocking-rate-and-sales-turnover-rate',
          sort: 435000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/storeOperationIndicator/stockingRateAndSalesTurnoverRate/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        }
      ]
    },
    {
      menuCode: '440000',
      parentCode: '400000',
      menuName: '购药者画像指标',
      menuIcon: 'sino-icon sino-icon-portrait1',
      url: 'drug-purchaser-portrait',
      sort: 440000,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: '',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '441000',
          parentCode: '440000',
          menuName: '性别/年龄段',
          menuIcon: '',
          url: 'sex-and-age',
          sort: 441000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserPortrait/sexAndAge/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '442000',
          parentCode: '440000',
          menuName: '新/老用户比例',
          menuIcon: '',
          url: 'user-proportion',
          sort: 442000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserPortrait/userProportion/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '443000',
          parentCode: '440000',
          menuName: '复购率',
          menuIcon: '',
          url: 'repurchase-rate',
          sort: 443000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserPortrait/repurchaseRate/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        }
      ]
    },
    {
      menuCode: '450000',
      parentCode: '400000',
      menuName: '购药者行为指标',
      menuIcon: 'sino-icon sino-icon-gouyaozhehangwei',
      url: 'drug-purchaser-behavior',
      sort: 450000,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: '',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '451000',
          parentCode: '450000',
          menuName: '渗透率',
          menuIcon: '',
          url: 'permeability',
          sort: 451000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/permeability/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '452000',
          parentCode: '450000',
          menuName: '人均消费金额/件数',
          menuIcon: '',
          url: 'per-capita-consumption',
          sort: 452000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/perCapitaConsumption/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '453000',
          parentCode: '450000',
          menuName: '客单价',
          menuIcon: '',
          url: 'customer-unit-price',
          sort: 453000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/customerUnitPrice/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '454000',
          parentCode: '450000',
          menuName: '品单价',
          menuIcon: '',
          url: 'product-unit-price',
          sort: 454000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/productUnitPrice/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '455000',
          parentCode: '450000',
          menuName: '客品数',
          menuIcon: '',
          url: 'customer-product-number',
          sort: 455000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/customerProductNumber/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '456000',
          parentCode: '450000',
          menuName: '消费频次',
          menuIcon: '',
          url: 'consumption-frequency',
          sort: 456000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/consumptionFrequency/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '457000',
          parentCode: '450000',
          menuName: '可服用天数',
          menuIcon: '',
          url: 'number-of-days-for-taking-medicine',
          sort: 457000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/numberOfDaysForTakingMedicine/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        }
      ]
    },
    {
      menuCode: '460000',
      parentCode: '400000',
      menuName: '关联与流转',
      menuIcon: 'sino-icon sino-icon-exchange',
      url: 'relative-and-slip',
      sort: 460000,
      type: 1,
      description: '',
      channel: 1,
      perms: null,
      open: null,
      parentName: null,
      packageAddress: '',
      showType: 1,
      menuLevel: 2,
      menuType: 2,
      child: [
        {
          menuCode: '461000',
          parentCode: '460000',
          menuName: '关联购买',
          menuIcon: '',
          url: 'relative-purchase',
          sort: 461000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/relativeAndSlip/relativePurchase/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        },
        {
          menuCode: '462000',
          parentCode: '460000',
          menuName: '品牌流转',
          menuIcon: '',
          url: 'brand-slip',
          sort: 462000,
          type: 1,
          description: '',
          channel: 1,
          perms: null,
          open: null,
          parentName: null,
          packageAddress: 'views/indicatorLibrary/relativeAndSlip/brandSlip/index',
          showType: 1,
          menuLevel: 3,
          menuType: 2,
          child: []
        }
      ]
    }
  ]
}

export const mockMenuList = [
  // {
  //   menuCode: '400000',
  //   parentCode: '0',
  //   menuName: '指标库',
  //   menuIcon: '',
  //   url: 'indicator-library',
  //   sort: 400000,
  //   type: 1,
  //   description: '',
  //   channel: 1,
  //   perms: null,
  //   open: null,
  //   parentName: null,
  //   packageAddress: '',
  //   showType: 1,
  //   menuLevel: 1,
  //   menuType: 2,
  //   child: [
  //     {
  //       menuCode: '410000',
  //       parentCode: '400000',
  //       menuName: '增长驱动模型',
  //       menuIcon: 'sino-icon sino-icon-model',
  //       url: 'growth-model',
  //       sort: 410000,
  //       type: 1,
  //       description: '',
  //       channel: 1,
  //       perms: null,
  //       open: null,
  //       parentName: null,
  //       packageAddress: 'views/indicatorLibrary/growthModel/index',
  //       showType: 1,
  //       menuLevel: 2,
  //       menuType: 2,
  //       child: []
  //     },
  //     {
  //       menuCode: '420000',
  //       parentCode: '400000',
  //       menuName: '市场表现概览',
  //       menuIcon: 'sino-icon sino-icon-a-marketanalysis',
  //       url: 'market-performance',
  //       sort: 420000,
  //       type: 1,
  //       description: '',
  //       channel: 1,
  //       perms: null,
  //       open: null,
  //       parentName: null,
  //       packageAddress: 'views/indicatorLibrary/marketPerformance/index',
  //       showType: 1,
  //       menuLevel: 2,
  //       menuType: 2,
  //       child: []
  //     },
  //     {
  //       menuCode: '430000',
  //       parentCode: '400000',
  //       menuName: '门店运营指标',
  //       menuIcon: 'sino-icon sino-icon-indicator',
  //       url: 'store-operation-indicator',
  //       sort: 430000,
  //       type: 1,
  //       description: '',
  //       channel: 1,
  //       perms: null,
  //       open: null,
  //       parentName: null,
  //       packageAddress: '',
  //       showType: 1,
  //       menuLevel: 2,
  //       menuType: 2,
  //       child: [
  //         {
  //           menuCode: '431000',
  //           parentCode: '430000',
  //           menuName: '销售额/订单量占比',
  //           menuIcon: '',
  //           url: 'sales-volume-and-order-proportion',
  //           sort: 431000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/storeOperationIndicator/salesVolumeAndOrderProportion/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '432000',
  //           parentCode: '430000',
  //           menuName: '店均销售额/订单量',
  //           menuIcon: '',
  //           url: 'sales-volume-and-order',
  //           sort: 432000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/storeOperationIndicator/salesVolumeAndOrder/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '433000',
  //           parentCode: '430000',
  //           menuName: '进货/销售均价',
  //           menuIcon: '',
  //           url: 'purchase-goods-dnd-sales-average-price',
  //           sort: 433000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/storeOperationIndicator/purchaseGoodsAndSalesAveragePrice/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '434000',
  //           parentCode: '430000',
  //           menuName: '毛利额/毛利率',
  //           menuIcon: '',
  //           url: 'gross-profit',
  //           sort: 434000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/storeOperationIndicator/grossProfit/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '435000',
  //           parentCode: '430000',
  //           menuName: '铺货率/动销率',
  //           menuIcon: '',
  //           url: 'stocking-rate-and-sales-turnover-rate',
  //           sort: 435000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/storeOperationIndicator/stockingRateAndSalesTurnoverRate/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         }
  //       ]
  //     },
  //     {
  //       menuCode: '440000',
  //       parentCode: '400000',
  //       menuName: '购药者画像指标',
  //       menuIcon: 'sino-icon sino-icon-portrait1',
  //       url: 'drug-purchaser-portrait',
  //       sort: 440000,
  //       type: 1,
  //       description: '',
  //       channel: 1,
  //       perms: null,
  //       open: null,
  //       parentName: null,
  //       packageAddress: '',
  //       showType: 1,
  //       menuLevel: 2,
  //       menuType: 2,
  //       child: [
  //         {
  //           menuCode: '441000',
  //           parentCode: '440000',
  //           menuName: '性别/年龄段',
  //           menuIcon: '',
  //           url: 'sex-and-age',
  //           sort: 441000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserPortrait/sexAndAge/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '442000',
  //           parentCode: '440000',
  //           menuName: '新/老用户比例',
  //           menuIcon: '',
  //           url: 'user-proportion',
  //           sort: 442000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserPortrait/userProportion/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '443000',
  //           parentCode: '440000',
  //           menuName: '复购率',
  //           menuIcon: '',
  //           url: 'repurchase-rate',
  //           sort: 443000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserPortrait/repurchaseRate/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         }
  //       ]
  //     },
  //     {
  //       menuCode: '450000',
  //       parentCode: '400000',
  //       menuName: '购药者行为指标',
  //       menuIcon: 'sino-icon sino-icon-gouyaozhehangwei',
  //       url: 'drug-purchaser-behavior',
  //       sort: 450000,
  //       type: 1,
  //       description: '',
  //       channel: 1,
  //       perms: null,
  //       open: null,
  //       parentName: null,
  //       packageAddress: '',
  //       showType: 1,
  //       menuLevel: 2,
  //       menuType: 2,
  //       child: [
  //         {
  //           menuCode: '451000',
  //           parentCode: '450000',
  //           menuName: '渗透率',
  //           menuIcon: '',
  //           url: 'permeability',
  //           sort: 451000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/permeability/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '452000',
  //           parentCode: '450000',
  //           menuName: '人均消费金额/件数',
  //           menuIcon: '',
  //           url: 'per-capita-consumption',
  //           sort: 452000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/perCapitaConsumption/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '453000',
  //           parentCode: '450000',
  //           menuName: '客单价',
  //           menuIcon: '',
  //           url: 'customer-unit-price',
  //           sort: 453000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/customerUnitPrice/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '454000',
  //           parentCode: '450000',
  //           menuName: '品单价',
  //           menuIcon: '',
  //           url: 'product-unit-price',
  //           sort: 454000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/productUnitPrice/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '455000',
  //           parentCode: '450000',
  //           menuName: '客品数',
  //           menuIcon: '',
  //           url: 'customer-product-number',
  //           sort: 455000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/customerProductNumber/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '456000',
  //           parentCode: '450000',
  //           menuName: '消费频次',
  //           menuIcon: '',
  //           url: 'consumption-frequency',
  //           sort: 456000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/drugPurchaserBehavior/consumptionFrequency/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         }
  //       ]
  //     },
  //     {
  //       menuCode: '460000',
  //       parentCode: '400000',
  //       menuName: '关联与流转',
  //       menuIcon: 'sino-icon sino-icon-exchange',
  //       url: 'relative-and-slip',
  //       sort: 460000,
  //       type: 1,
  //       description: '',
  //       channel: 1,
  //       perms: null,
  //       open: null,
  //       parentName: null,
  //       packageAddress: '',
  //       showType: 1,
  //       menuLevel: 2,
  //       menuType: 2,
  //       child: [
  //         {
  //           menuCode: '461000',
  //           parentCode: '460000',
  //           menuName: '关联购买',
  //           menuIcon: '',
  //           url: 'relative-purchase',
  //           sort: 461000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/relativeAndSlip/relativePurchase/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         },
  //         {
  //           menuCode: '462000',
  //           parentCode: '460000',
  //           menuName: '品牌流转',
  //           menuIcon: '',
  //           url: 'brand-slip',
  //           sort: 462000,
  //           type: 1,
  //           description: '',
  //           channel: 1,
  //           perms: null,
  //           open: null,
  //           parentName: null,
  //           packageAddress: 'views/indicatorLibrary/relativeAndSlip/brandSlip/index',
  //           showType: 1,
  //           menuLevel: 3,
  //           menuType: 2,
  //           child: []
  //         }
  //       ]
  //     }
  //   ]
  // }
]

// 品类分析-驾驶舱
export const mockCategoryAnalysisDashboardMenu = {
  menuCode: '2000001',
  parentCode: '0',
  menuName: '品类驾驶舱',
  menuIcon: '',
  url: 'temporary-category-analysis-dashboard',
  sort: 2001,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: 'views/categoryAnalysis/dashboardRefactor/index',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: []
}

// 品牌分析-驾驶舱
export const mockBrandAnalysisDashboardMenu = {
  menuCode: '3000001',
  parentCode: '0',
  menuName: '品牌驾驶舱',
  menuIcon: '',
  url: 'temporary-brand-analysis-dashboard',
  sort: 3001,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: 'views/brandAnalysis/dashboardRefactor/index',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: []
}

/**
 * 品牌分析-品牌运营指标对比
 */
export const mockBrandAnalysisBrandOperationIndicatorCompareMenu = {
  menuCode: '3000002',
  parentCode: '0',
  menuName: '品牌运营指标对比',
  menuIcon: '',
  url: 'temporary-brand-analysis-brand-operation-indicator-compare',
  sort: 3002,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: 'views/brandAnalysis/competitionOverview/indicatorTrend/brandOperationCompare/index',
  showType: 1,
  menuLevel: 1,
  menuType: 2,
  child: []
}

/**
 * 智能助手
 */
export const mockAiHelperMenu = {
  menuCode: '600000',
  parentCode: '0',
  menuName: '智能助手',
  menuIcon: '',
  url: 'ai-helper',
  sort: 6000,
  type: 1,
  description: '',
  channel: 1,
  perms: null,
  open: null,
  parentName: null,
  packageAddress: 'views/aiHelper/index',
  showType: 0,
  menuLevel: 1,
  menuType: 2,
  child: []
}
